"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBookingCashOnly = isBookingCashOnly;
function isBookingCashOnly(originCountryNameOrIsoCode, destinationCountryNameOrIsoCode) {
    if (!originCountryNameOrIsoCode || !destinationCountryNameOrIsoCode) {
        return false;
    }
    // we allow only cash payment in Cuba
    const cashOnlyCountryEnglishNamesOrIso = ["Cuba", "cu"];
    const isRouteInCashOnlyCountry = cashOnlyCountryEnglishNamesOrIso.find((name) => name === originCountryNameOrIsoCode || name === destinationCountryNameOrIsoCode);
    return !!isRouteInCashOnlyCountry;
}
//# sourceMappingURL=is-booking-cache-only.js.map